import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { empty } from 'rxjs/observable/empty';
import captureError from '../../helpers/errors';

const decamelize = (str, separator = '_') =>
  str
    .replace(/([a-z\d])([A-Z])/g, `$1${separator}$2`)
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, `$1${separator}$2`)
    .toLowerCase();

const mapErrorsWithPath = (errors, path, config) =>
  errors
    .filter(
      (error) =>
        error.path === path && (config.allowEmptyFields || error.field.length)
    )
    .map((error) => {
      const { path: mutationPath, ...extra } = error;

      if (!error.field) {
        // Prevent capturing errors related to field validation
        captureError({
          name: 'GraphQL Mutation Error',
          message: `Apollo Client failed to execute ${mutationPath} mutation`,
          tags: [{ name: 'error_type', value: 'graphqlMutation' }],
          extra,
        });
      }

      return error;
    })
    .reduce(
      (prev, error) => ({
        ...prev,
        [[config.prefix, decamelize(error.field)]
          .filter((c) => !!c)
          .join('_')]: {
          ...error,
          id: `${config.idPrefix || 'errors.'}${error.id}`,
        },
      }),
      {}
    );

const generateErrorMap = (config, errors) =>
  Object.keys(config).reduce(
    (prev, path) => ({
      ...prev,
      ...mapErrorsWithPath(
        errors,
        path,
        typeof config[path] === 'string'
          ? { prefix: config[path] }
          : config[path]
      ),
    }),
    {}
  );

const catchReduxFormMutationErrors = (form, config) =>
  catchError((error) => {
    if (!error.graphQLErrors) {
      throw error;
    }
    const errorMap = generateErrorMap(config, error.graphQLErrors);

    return of({ errorMap });
  });

const catchUnexpectedErrors = () =>
  catchError((error) => {
    console.error('Unexpected error:', error); // eslint-disable-line
    return empty();
  });

export {
  mapErrorsWithPath,
  generateErrorMap,
  catchUnexpectedErrors,
  catchReduxFormMutationErrors,
};
